import Service from "./Service";
const baseurl = '/api/historia-educacion';

export default {
    showByHc(idHistoria) {
        return Service.get(`${baseurl}/show-by-hc/${idHistoria}`);
    },
    store(data) {
        return Service.post(`${baseurl}/store`, data);
    }
}
